import { Model } from 'libx'
import { observable } from 'mobx'
import moment from 'moment'
import uniqueId from 'lodash/uniqueId'
import { omitUndefined } from 'utils/objectUtil'

export default class Amendment extends Model {
  cid = uniqueId('amendment-')

  @observable id
  @observable dateCreated
  @observable description = ''
  @observable customerAmount = 0

  constructor (attrs, opts) {
    super(...arguments)
    this.job = opts.job
  }

  parse (json) {
    return omitUndefined({
      id: json.date_created,
      dateCreated: moment(json.date_created),
      description: json.description,
      customerAmount: json.customer_amount
    })
  }
}



// WEBPACK FOOTER //
// ./src/client/domain/Amendment.js